<div class="ou-project-list-header">
  <div class="ou-project-add">
    <app-button
      *ngIf="user.isSuperAdminIn(organizationUnit.name)"
      (click)="createProject()"
      [title]="'Új projekt'"
      [icon]="'library_add'"
      [fontSize]="18"
    ></app-button>
  </div>
</div>
<div class="ou-project-list-item-container">
  <a
    class="ou-project-list-item"
    *ngFor="let item of projectList;"
    [routerLink]="'/project/get'"
    [queryParams]="{id: item.id}"
  >
    <div class="ou-project-list-card">
      <p>{{item.name}}</p>
    </div>
  </a>
</div>
